(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const initCollagePersonalizer = (root) => {
    const preview = root.querySelector('[data-renao-collage-preview]');
    const ark2Fields = Array.from(root.querySelectorAll('[data-ark2-field]'));
    const isGarage = root.dataset.renaoSourceProductHandle === 'ark3';
    const isWanted = root.dataset.renaoSourceProductHandle === 'suc';
    const arkadas3Fields = Array.from(root.querySelectorAll('[data-arkadas3-field]'));
    const bulkInput = root.querySelector('[data-renao-collage-bulk-input]');
	    const bulkButton = root.querySelector('[data-renao-collage-bulk-button]');
	    const captionInput = root.querySelector('[data-renao-collage-caption-input]');
	    const captionPreview = root.querySelector('[data-renao-collage-caption-preview]');
	    const captionCount = root.querySelector('[data-renao-collage-caption-count]');
	    const zrfkNoteInput = root.querySelector('[data-renao-zrfk-note-input]');
	    const zrfkNotePreview = root.querySelector('[data-renao-zrfk-note-preview]');
	    const zrfkNoteCount = root.querySelector('[data-renao-zrfk-note-count]');
	    const zrfkNoteStyleProperty = root.querySelector('[data-renao-zrfk-note-style-property]');
	    const zrfkNoteStyleButtons = root.querySelectorAll('[data-renao-zrfk-note-style]');
	    const progressCount = root.querySelector('[data-renao-collage-count]');
	    const orderStatus = root.querySelector('[data-renao-collage-order-status]');
	    const qualityStatus = root.querySelector('[data-renao-collage-quality-status]');
	    const toneProperty = root.querySelector('[data-renao-collage-tone-property]');
	    const toneButtons = root.querySelectorAll('[data-renao-collage-tone-option]');
	    const visualStyleInput = root.querySelector('[data-renao-visual-style-input]');
	    const visualStyleOptions = root.querySelectorAll('[data-renao-visual-style-option]');
	    const visualStyleNote = root.querySelector('[data-renao-visual-style-note]');
	    const babyNameInput = root.querySelector('[data-renao-baby-name-input]');
	    const babyDateInput = root.querySelector('[data-renao-baby-date-input]');
	    const babyNoteInput = root.querySelector('[data-renao-baby-note-input]');
	    const babyNamePreview = root.querySelector('[data-renao-baby-name-preview]');
	    const babyDatePreview = root.querySelector('[data-renao-baby-date-preview]');
	    const babyNotePreview = root.querySelector('[data-renao-baby-note-preview]');
	  const proofOpen = root.querySelector('[data-renao-collage-proof-open]');
    const proofModal = root.querySelector('[data-renao-collage-proof-modal]');
    const proofStage = root.querySelector('[data-renao-collage-proof-stage]');
    const proofCloseButtons = root.querySelectorAll('[data-renao-collage-proof-close]');
    const cropModal = root.querySelector('[data-renao-collage-crop]');
    const cropStage = root.querySelector('[data-renao-collage-crop-stage]');
    const cropImage = root.querySelector('[data-renao-collage-crop-image]');
    const cropZoom = root.querySelector('[data-renao-collage-crop-zoom]');
    const cropApply = root.querySelector('[data-renao-collage-crop-apply]');
    const cropCancelButtons = root.querySelectorAll('[data-renao-collage-crop-cancel]');
    const cropMoveButtons = root.querySelectorAll('[data-renao-collage-crop-move]');
    const cropZoomStepButtons = root.querySelectorAll('[data-renao-collage-crop-zoom-step]');
    const cropReset = root.querySelector('[data-renao-collage-crop-reset]');
    const previewOriginalParent = preview?.parentElement || null;
    const previewOriginalNext = preview?.nextSibling || null;

    if (!preview) return;
    if (babyNameInput && ['bebe2', 'bebe'].includes(root.dataset.renaoSourceProductHandle)) {
      babyNameInput.maxLength = 16;
    }
    if (cropModal && cropModal.parentElement !== document.body) document.body.appendChild(cropModal);
    if (proofModal && proofModal.parentElement !== document.body) document.body.appendChild(proofModal);
    if (cropImage) cropImage.draggable = false;

    const slotCount = Math.max(1, Number(root.dataset.renaoCollagePhotoCount || 6) || 6);
    const slots = Array.from({ length: slotCount }, (_, index) => {
      const slot = index + 1;
      return {
        slot,
	        input: (() => { const input = root.querySelector(`[data-renao-collage-input="${slot}"]`); if (input) input.name = `properties[Fotoğraf ${slot}]`; return input; })(),
	        slotElement: root.querySelector(`[data-renao-collage-slot="${slot}"]`),
        pick: root.querySelector(`[data-renao-collage-pick="${slot}"]`),
        adjust: root.querySelector(`[data-renao-collage-adjust="${slot}"]`),
        frame: root.querySelector(`[data-renao-collage-frame="${slot}"]`),
        image: root.querySelector(`[data-renao-collage-preview-image="${slot}"]`),
        placeholder: root.querySelector(`[data-renao-collage-placeholder="${slot}"]`),
        fileName: root.querySelector(`[data-renao-collage-file-name="${slot}"]`),
	        position: root.querySelector(`[data-renao-collage-position="${slot}"]`),
	        file: null,
	        objectUrl: '',
        existingUrl: '',
        upload: null,
        preserveInput: null,
        scale: 1,
        x: 0,
        y: 0,
        referenceWidth: 0,
        referenceHeight: 0,
      };
    });
    const originalPhotoUploadEndpoint = 'https://renao-customer-photos.renaogift.workers.dev/api/customer-photos';
    const originalPhotoUploadToken = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
        const random = Math.floor(Math.random() * 16);
        return (character === 'x' ? random : (random & 0x3) | 0x8).toString(16);
      });

    const uploadOriginalPhoto = (slotState) => {
      const file = slotState?.file;
      if (!(file instanceof File) || !file.name || file.size <= 0) return Promise.resolve(slotState?.existingUrl || '');
      if (!slotState.upload || slotState.upload.file !== file) {
        slotState.upload = { file, promise: null, url: '', error: null };
      }
      const upload = slotState.upload;
      if (upload.url) return Promise.resolve(upload.url);
      if (upload.promise) return upload.promise;

      const url = new URL(originalPhotoUploadEndpoint);
      upload.token ||= window.crypto?.randomUUID?.() || `${originalPhotoUploadToken.slice(0,24)}${Math.random().toString(16).slice(2).padEnd(12, '0').slice(0,12)}`;
      url.searchParams.set('token', upload.token);
      url.searchParams.set('slot', String(slotState.slot));
      url.searchParams.set('fileName', file.name || `foto-${slotState.slot}.jpg`);
      upload.error = null;
      upload.promise = fetch(url.toString(), {
        method: 'POST',
        headers: { 'Content-Type': file.type || 'image/jpeg' },
        body: file,
        credentials: 'omit',
      })
        .then(async (response) => {
          if (!response.ok) throw new Error(await response.text() || `Fotoğraf ${slotState.slot} yüklenemedi.`);
          return response.json();
        })
        .then((result) => {
          if (!result?.url) throw new Error(`Fotoğraf ${slotState.slot} bağlantısı oluşturulamadı.`);
          upload.url = String(result.url);
          return upload.url;
        })
        .catch((error) => {
          const rawMessage = String(error?.message || '');
          const isNetworkError = /load failed|failed to fetch|networkerror|network request failed/i.test(rawMessage);
          const customerError = isNetworkError
            ? new Error('Fotoğraflar yüklenemedi. İnternet bağlantınızı kontrol edip fotoğrafları yeniden seçerek tekrar deneyin. Ürün sepete eklenmedi.')
            : error;
          upload.error = customerError;
          upload.promise = null;
          throw customerError;
        });
      return upload.promise;
    };

    root.dataset.renaoFileManaged = 'true';
    root.__renaoCollageSlots = slots;
    root.renaoHasManagedFiles = () => slots.some((slotState) => (
      Boolean(slotState.file)
      || Boolean(slotState.input?.files && slotState.input.files.length > 0)
      || Boolean(slotState.input?.__renaoPendingFile instanceof File && slotState.input.__renaoPendingFile.size > 0)
    ));
    root.renaoAppendManagedFiles = (formData) => {
      if (!formData) return false;
      let appended = false;
      slots.forEach((slotState) => {
        const file = slotState.file || slotState.input?.__renaoPendingFile || slotState.input?.files?.[0] || null;
        const fieldName = slotState.input?.name;
        if (!fieldName) return;
        const storedUrl = slotState.upload?.url || (!file ? slotState.existingUrl : '');
        if (!storedUrl) return;
        formData.delete(fieldName);
        formData.append(fieldName, storedUrl);
        appended = true;
      });
      return appended;
    };
    root.renaoPrepareManagedFiles = async () => {
      const pending = slots.filter((slotState) => slotState.file instanceof File);
      if (!pending.length) return true;
      if (orderStatus) orderStatus.textContent = `Orijinal fotoğraflar yükleniyor (0/${pending.length})…`;
      let completed = 0;
      await Promise.all(pending.map((slotState) => uploadOriginalPhoto(slotState).then((url) => {
        completed += 1;
        if (orderStatus) orderStatus.textContent = `Orijinal fotoğraflar yükleniyor (${completed}/${pending.length})…`;
        return url;
      })));
      if (orderStatus) orderStatus.textContent = 'Fotoğraflar yüklendi. Sipariş sepete ekleniyor…';
      return true;
    };
    root.renaoHasCollageFiles = root.renaoHasManagedFiles;
    root.renaoAppendCollageFiles = root.renaoAppendManagedFiles;

	  let activeSlot = null;
	  let dragState = null;
	  let draggedSlot = null;
	  const captionMaxLength = Number(captionInput?.maxLength || 27);
	  const defaultCaption = root.dataset.renaoCollageDefaultCaption || 'birlikte biriktirdiklerimiz';
	  const stripEmoji = (value) => {
	    const stringValue = String(value ?? '');
	    const sanitizer = globalThis.RenaoCustomerTextSanitizer;
	    if (sanitizer?.stripEmoji) return sanitizer.stripEmoji(stringValue);
	    return stringValue.replace(/(?:\p{Regional_Indicator}+|[#*0-9]\uFE0F?\u20E3|\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|\p{Emoji_Modifier})?)*|\p{Emoji_Modifier}|[\u200D\uFE0E\uFE0F]|[\u{E0020}-\u{E007F}])/gu, '');
	  };
	  const normalizeCaptionCharacters = (value) => String(value || '')
	    .replace(/[ğĞ]/g, 'g')
	    .replace(/[şŞ]/g, 's')
	    .replace(/[çÇ]/g, 'c')
	    .replace(/[ıİ]/g, 'i')
	    .replace(/[öÖ]/g, 'o')
	    .replace(/[üÜ]/g, 'u');
	  const defaultOrderHint = 'Sıralamak için kartı tutup sürükleyin.';
	  let captionFitFrame = 0;
    let babyNameFitFrame = 0;
    const isPremiumHorizontal = ['premium-yatay-3', 'zarif-yatay-3'].includes(root.dataset.renaoProductHandle);

    const minimumPhotoSize = slotCount === 1
      ? { shortEdge: 600, longEdge: 800 }
      : slotCount <= 3
        ? { shortEdge: 450, longEdge: 600 }
        : { shortEdge: 350, longEdge: 450 };

    const readImageSize = (file) => new Promise((resolve) => {
      if (!file || !String(file.type || '').startsWith('image/')) {
        resolve(null);
        return;
      }

      const imageUrl = URL.createObjectURL(file);
      const image = new Image();
      let finished = false;
      const finish = (size) => {
        if (finished) return;
        finished = true;
        window.clearTimeout(image._renaoQualityTimer);
        URL.revokeObjectURL(imageUrl);
        resolve(size);
      };

      image.onload = () => finish({ width: image.naturalWidth, height: image.naturalHeight });
      image.onerror = () => finish(null);
      image._renaoQualityTimer = window.setTimeout(() => finish(null), 8000);
      image.src = imageUrl;
    });

    const checkPhotoQuality = async (file) => {
      const size = await readImageSize(file);
      if (!size?.width || !size?.height) return { accepted: true, size: null };
      const shortEdge = Math.min(size.width, size.height);
      const longEdge = Math.max(size.width, size.height);
      return {
        accepted: shortEdge >= minimumPhotoSize.shortEdge && longEdge >= minimumPhotoSize.longEdge,
        size,
      };
    };

    // Upload the exact customer file. The print PDF already crops from source
    // pixels and exports at production DPI, so resizing or JPEG re-encoding at
    // this stage can only discard detail before the order reaches production.
    const preparePhotoForShopify = async (file) => file;

    const qualityMessage = (rejectedItems) => {
      if (!rejectedItems.length) return '';
      const labels = rejectedItems.map(({ index, result }) => (
        `${index + 1}. fotoğraf (${result.size.width}×${result.size.height} px)`
      ));
      return `${labels.join(', ')} baskı için çok küçük. Lütfen kısa kenarı en az ${minimumPhotoSize.shortEdge} px, uzun kenarı en az ${minimumPhotoSize.longEdge} px olan başka bir fotoğraf seçin.`;
    };

    const showQualityMessage = (message) => {
      if (qualityStatus) qualityStatus.textContent = message || '';
      if (orderStatus && message) orderStatus.textContent = message;
    };

    const getProductForm = () => root.closest('form');

    const getProductMediaWrapper = () => {
      const product = root.closest('.product') || document.querySelector('.product');
      return product ? product.querySelector('.product__media-wrapper') : null;
    };

    const showProductMedia = () => {
      const mediaWrapper = getProductMediaWrapper();
      if (mediaWrapper) {
        mediaWrapper.classList.remove('has-renao-live-preview');
        mediaWrapper.classList.remove('is-renao-media-returning');
        void mediaWrapper.offsetWidth;
        mediaWrapper.classList.add('is-renao-media-returning');
        window.setTimeout(() => mediaWrapper.classList.remove('is-renao-media-returning'), 900);
      }

      root.classList.remove('has-renao-live-preview');
      if (previewOriginalParent && preview.parentElement !== previewOriginalParent) {
        previewOriginalParent.insertBefore(preview, previewOriginalNext);
      }
    };

    const ensureLivePreviewDock = (mediaWrapper) => {
      let dock = mediaWrapper.querySelector('[data-renao-collage-live-preview-dock]');
      if (dock) return dock;

      dock = document.createElement('div');
      dock.className = 'renao-live-preview-dock renao-live-preview-dock--collage';
      dock.dataset.renaoCollageLivePreviewDock = '';
      dock.innerHTML = `
        <div class="renao-live-preview-dock__bar">
          <span class="renao-live-preview-dock__title">
            <span class="renao-live-preview-dock__mark" aria-hidden="true"></span>
            <span>
              <strong>Canlı önizleme</strong>
              <small>Baskıdan önceki son tasarım</small>
            </span>
          </span>
          <button type="button" data-renao-collage-show-product-media>Ürün fotoğrafları</button>
        </div>
        <div class="renao-live-preview-dock__slot" data-renao-collage-live-preview-slot></div>
      `;
      mediaWrapper.insertBefore(dock, mediaWrapper.firstChild);
      dock.querySelector('[data-renao-collage-show-product-media]')?.addEventListener('click', showProductMedia);
      return dock;
    };

    const showLivePreview = () => {
      const mediaWrapper = getProductMediaWrapper();
      if (!mediaWrapper) return;

      const dock = ensureLivePreviewDock(mediaWrapper);
      const slot = dock.querySelector('[data-renao-collage-live-preview-slot]');
      if (!slot) return;

      if (preview.parentElement !== slot) slot.appendChild(preview);
      mediaWrapper.classList.remove('is-renao-media-returning');
      mediaWrapper.classList.add('has-renao-live-preview');
      root.classList.add('has-renao-live-preview');
      window.requestAnimationFrame(() => {
        syncAllTransforms();
        window.requestAnimationFrame(syncAllTransforms);
      });
    };

    const activateLivePreview = (event) => {
      if (event?.target?.closest?.('[data-renao-collage-crop]')) return;
      showLivePreview();
    };

	    const setInputFile = (input, file) => {
	      if (!input || !file) return false;
	      input.__renaoPendingFile = file;
	      if (typeof DataTransfer === 'undefined') return false;
      try {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
        input.__renaoPendingFile = null;
        return true;
      } catch (error) {
        console.warn('Renao collage file could not be assigned to slot input.', error);
        return false;
	      }
	    };

	    const clearInputFile = (input) => {
	      if (!input) return;
	      input.__renaoPendingFile = null;
	      try {
	        if (typeof DataTransfer !== 'undefined') {
	          input.files = new DataTransfer().files;
	        } else {
	          input.value = '';
	        }
	      } catch (error) {
	        input.value = '';
	      }
	    };

    const hasSlotFile = (slotState) => Boolean(
      slotState.objectUrl
      || slotState.existingUrl
      || (slotState.input?.files && slotState.input.files.length > 0)
    );

	    const hasAllPhotos = () => slots.every(hasSlotFile);

    let cropPreparationTimer = 0;
    const prepareCropsInBackground = () => {
      window.clearTimeout(cropPreparationTimer);
      if (!hasAllPhotos()) return;
      cropPreparationTimer = window.setTimeout(() => {
        const form = getProductForm();
        if (['bebe4', 'bebe3', 'bebe2', 'bebe'].includes(root.dataset.renaoSourceProductHandle)) {
          globalThis.RenaoCropRecipe?.syncForm?.(form);
          return;
        }
        const queuedProduction = Boolean(form?.querySelector(
          '[name="properties[_Renao Üretim]"][value="mac-pdf-v1"]'
        )) && window.RenaoDesignFileLocalOnly !== true;
        // Queued orders retain the original customer files and the exact crop
        // recipe. Freezing a browser-side crop resets x/y/zoom to identity;
        // that would make the later production renderer lose the customer's
        // positioning while still pointing at the uncropped original photo.
        if (queuedProduction) return;
        const prepare = globalThis.RenaoCropRecipe?.prepareForm;
        if (!form || typeof prepare !== 'function') return;
        Promise.resolve(prepare(form)).catch((error) => {
          // Keep editing and add-to-cart interaction unchanged. The submit
          // handler performs the same check once more and surfaces a useful
          // message only if the final crop still cannot be prepared.
          console.warn('Renao collage crop could not be prepared in background.', error);
        });
      }, 120);
    };

	    const setTone = (tone) => {
	      const normalizedTone = tone === 'bw' ? 'bw' : 'color';
	      const label = normalizedTone === 'bw' ? 'Siyah beyaz' : 'Renkli';
	      const plaque = preview.querySelector('.renao-collage-plaque');

	      root.dataset.renaoCollageTone = normalizedTone;
	      preview.dataset.renaoCollageTone = normalizedTone;
	      if (plaque) plaque.dataset.renaoCollageTone = normalizedTone;
	      if (toneProperty) toneProperty.value = label;

	      toneButtons.forEach((button) => {
	        const isSelected = button.dataset.renaoCollageToneOption === normalizedTone;
	        button.classList.toggle('is-selected', isSelected);
	        button.setAttribute('aria-pressed', String(isSelected));
	      });
	    };

	    const setVisualStyle = (value) => {
	      if (!visualStyleInput) return;
	      const selectedValue = String(value || visualStyleInput.value || 'Fotoğraf olarak kalsın');
	      const normalizedValue = selectedValue.toLocaleLowerCase('tr-TR').includes('karikatür')
	        ? 'Karikatür tasarım yapılsın'
	        : 'Fotoğraf olarak kalsın';

	      visualStyleInput.value = normalizedValue;
	      root.dataset.renaoVisualStyle = normalizedValue;
	      visualStyleOptions.forEach((button) => {
	        const isSelected = button.dataset.renaoVisualStyleOption === normalizedValue;
	        button.classList.toggle('is-selected', isSelected);
	        button.setAttribute('aria-pressed', String(isSelected));
	      });

	      if (visualStyleNote) {
	        visualStyleNote.textContent = normalizedValue === 'Karikatür tasarım yapılsın'
	          ? 'Karikatür tasarım seçildi. Önizleme fotoğraf yerleşimini gösterir; nihai çizim tasarım ekibimiz tarafından hazırlanır.'
	          : 'Fotoğraf olarak kalsın seçildi. Yüklediğiniz fotoğraf baskı önizlemesindeki gibi kullanılır.';
	      }
	    };

	    const updateProgress = () => {
	      const loadedCount = slots.filter(hasSlotFile).length;
	      if (progressCount) progressCount.textContent = `${loadedCount}/${slots.length} fotoğraf`;
	      root.classList.toggle('has-renao-collage-complete', loadedCount === slots.length);
      if (['arkadas', 'arkadas2'].includes(root.dataset.renaoSourceProductHandle)) {
        root.dispatchEvent(new CustomEvent('renao:arkadas:photos', { detail: { count: loadedCount, total: slots.length } }));
      }
	    };

	    const updateError = () => {
	      updateProgress();
	      root.classList.toggle('has-renao-collage-error', !hasAllPhotos());
	    };

    const clampZoom = (value) => clamp(Number(value || 1), 1, 2.8);

    const getStageForSlot = (slotState) => {
      if (activeSlot === slotState && cropStage && !cropModal?.hidden && cropStage.clientWidth && cropStage.clientHeight) return cropStage;
      const previewStage = slotState.image?.parentElement;
      if (previewStage?.clientWidth && previewStage?.clientHeight) return previewStage;
      return null;
    };

    const setSlotReferenceFromPreview = (slotState) => {
      const previewStage = slotState.image?.parentElement;
      const previewRect = previewStage?.getBoundingClientRect();
      const width = previewRect?.width || previewStage?.clientWidth || 0;
      const height = previewRect?.height || previewStage?.clientHeight || 0;
      if (!width || !height) return false;

      slotState.referenceWidth = width;
      slotState.referenceHeight = height;
      if (cropStage) cropStage.style.aspectRatio = `${width} / ${height}`;
      return true;
    };

    const clampSlotPosition = (slotState) => {
      const stage = getStageForSlot(slotState);
      if ((!slotState.referenceWidth || !slotState.referenceHeight) && !setSlotReferenceFromPreview(slotState) && stage) {
        slotState.referenceWidth = stage.clientWidth;
        slotState.referenceHeight = stage.clientHeight;
      }

      const width = slotState.referenceWidth || stage?.clientWidth || 0;
      const height = slotState.referenceHeight || stage?.clientHeight || 0;
      // Cart/order state is restored before the preview has a measurable box.
      // Do not clamp a saved pixel offset against the old 1px fallback: that
      // silently collapsed the customer's crop back to the centre in PDFs.
      if (!width || !height) return;
      if (!slotState.normalizedPositionApplied
        && Number.isFinite(slotState.normalizedX) && Number.isFinite(slotState.normalizedY)) {
        slotState.x = slotState.normalizedX * width;
        slotState.y = slotState.normalizedY * height;
        slotState.normalizedPositionApplied = true;
      }
      const maxX = Math.max(0, (width * (slotState.scale - 1)) / 2);
      const maxY = Math.max(0, (height * (slotState.scale - 1)) / 2);
      slotState.x = clamp(slotState.x, -maxX, maxX);
      slotState.y = clamp(slotState.y, -maxY, maxY);
      slotState.normalizedX = slotState.x / width;
      slotState.normalizedY = slotState.y / height;
    };

    const getTransformForStage = (slotState, targetStage) => {
      const referenceWidth = slotState.referenceWidth || cropStage?.clientWidth || targetStage?.clientWidth || 1;
      const referenceHeight = slotState.referenceHeight || cropStage?.clientHeight || targetStage?.clientHeight || 1;
      const ratioX = targetStage?.clientWidth ? targetStage.clientWidth / referenceWidth : 1;
      const ratioY = targetStage?.clientHeight ? targetStage.clientHeight / referenceHeight : 1;
      return `translate(${slotState.x * ratioX}px, ${slotState.y * ratioY}px) scale(${slotState.scale})`;
    };

    const syncSlotTransform = (slotState) => {
      clampSlotPosition(slotState);
      if (slotState.image) {
        const stage = slotState.image.parentElement || cropStage;
        slotState.image.style.transform = stage ? getTransformForStage(slotState, stage) : `scale(${slotState.scale})`;
        slotState.image.style.transformOrigin = 'center';
      }
      if (cropImage && activeSlot === slotState) {
        const stage = cropStage || cropImage.parentElement;
        cropImage.style.transform = stage ? getTransformForStage(slotState, stage) : `scale(${slotState.scale})`;
        cropImage.style.transformOrigin = 'center';
      }
      // The product form can be re-rendered by Shopify after this component is
      // initialized. Resolve the live hidden field again so crop data never
      // remains attached to a stale or missing node.
      if (!slotState.position || !slotState.position.isConnected) {
        slotState.position = document.querySelector(`[data-renao-collage-position="${slotState.slot}"]`)
          || root.querySelector(`[data-renao-collage-position="${slotState.slot}"]`);
      }
      if (slotState.position) {
        const normalized = Number.isFinite(slotState.normalizedX) && Number.isFinite(slotState.normalizedY)
          ? `, nx:${slotState.normalizedX.toFixed(6)}, ny:${slotState.normalizedY.toFixed(6)}`
          : '';
        const legacy = `x:${Math.round(slotState.x)}, y:${Math.round(slotState.y)}, zoom:${slotState.scale.toFixed(2)}${normalized}`;
        let serialized = legacy;
        try {
          if (globalThis.RenaoCropRecipe?.merge) {
            serialized = globalThis.RenaoCropRecipe.merge(
              slotState.position.value,
              legacy,
              slotState.image,
              slotState.image?.parentElement
            );
          }
        } catch (error) {
          // Legacy x/y/zoom/nx/ny remains sufficient to restore the exact
          // customer composition; the source crop can be rebuilt at submit.
          serialized = legacy;
        }
        document.querySelectorAll(`[data-renao-collage-position="${slotState.slot}"]`).forEach((input) => {
          input.value = serialized;
          input.setAttribute('value', serialized);
        });
        slotState.position.value = serialized;
        slotState.position.setAttribute('value', serialized);
      }
    };

	    const syncAllTransforms = () => {
	      slots.forEach(syncSlotTransform);
	    };

	    const fitCaption = () => {
	      if (!captionInput || !captionPreview) return;
      if (isGarage) {
        captionPreview.removeAttribute('textLength');
        captionPreview.style.fontSize = '24.8473px';
        const width = captionPreview.getComputedTextLength();
        if (width > 250) captionPreview.style.fontSize = `${24.8473 * 250 / width}px`;
        return;
      }
	      if (isWanted) {
        captionPreview.style.fontSize = '14.7578px';
        const width = captionPreview.getComputedTextLength();
        if (width > 235) captionPreview.style.fontSize = `${14.7578 * 235 / width}px`;
        return;
      }
      const captionLength = captionPreview.textContent.trim().length;
        if (isPremiumHorizontal && captionLength > 20) {
          captionPreview.setAttribute('textLength', '360');
          captionPreview.setAttribute('lengthAdjust', 'spacingAndGlyphs');
          return;
        }
	      if (typeof captionPreview.getComputedTextLength === 'function') {
	        captionPreview.removeAttribute('textLength');
	        captionPreview.removeAttribute('lengthAdjust');
	        const measuredWidth = captionPreview.getComputedTextLength();
	        const maxWidth = isPremiumHorizontal ? 326 : 286;
	        if (measuredWidth > maxWidth) {
	          captionPreview.setAttribute('textLength', String(maxWidth));
	          captionPreview.setAttribute('lengthAdjust', 'spacingAndGlyphs');
	        }
	      } else if (captionLength > 16) {
	        captionPreview.setAttribute('textLength', captionLength > 23 ? '286' : '276');
	        captionPreview.setAttribute('lengthAdjust', 'spacingAndGlyphs');
	      } else {
	        captionPreview.removeAttribute('textLength');
	        captionPreview.removeAttribute('lengthAdjust');
	      }
	    };

	    const scheduleCaptionFit = () => {
	      window.cancelAnimationFrame(captionFitFrame);
	      captionFitFrame = window.requestAnimationFrame(() => {
	        fitCaption();
	        window.requestAnimationFrame(fitCaption);
	      });
	    };

    const getSlotImageUrl = (slotState) => slotState.objectUrl || slotState.existingUrl || '';

    const getFileNameFromUrl = (value) => {
      const text = String(value || '');
      try {
        return decodeURIComponent(new URL(text, window.location.origin).pathname.split('/').pop() || text);
      } catch (error) {
        return text.split('/').pop() || text;
      }
    };

    const syncPreservedSlotUrl = (slotState) => {
      if (slotState.existingUrl && !slotState.file) {
        if (!slotState.preserveInput) {
          slotState.preserveInput = document.createElement('input');
          slotState.preserveInput.type = 'hidden';
          slotState.preserveInput.dataset.renaoCollageExistingPhoto = String(slotState.slot);
          slotState.slotElement?.appendChild(slotState.preserveInput);
        }
        slotState.preserveInput.name = `properties[Fotoğraf ${slotState.slot}]`;
      if (slotState.input) slotState.input.name = `properties[Fotoğraf ${slotState.slot}]`;
        slotState.preserveInput.value = slotState.existingUrl;
        slotState.preserveInput.disabled = false;
      } else if (slotState.preserveInput) {
        slotState.preserveInput.value = '';
        slotState.preserveInput.disabled = true;
      }
    };

	    const renderSlotState = (slotState, shouldAssignInput = true) => {
      const imageUrl = getSlotImageUrl(slotState);
	      if (imageUrl) {
	        if (slotState.file && shouldAssignInput) setInputFile(slotState.input, slotState.file);
        if (!slotState.file && shouldAssignInput) clearInputFile(slotState.input);
	        if (slotState.image) slotState.image.src = imageUrl;
	        if (slotState.placeholder) slotState.placeholder.hidden = true;
	        slotState.frame?.classList.add('has-photo');
	        if (slotState.fileName) slotState.fileName.textContent = slotState.file?.name || getFileNameFromUrl(slotState.existingUrl) || `Fotoğraf ${slotState.slot}`;
	        if (slotState.adjust) slotState.adjust.hidden = false;
	      } else {
	        if (shouldAssignInput) clearInputFile(slotState.input);
	        if (slotState.image) slotState.image.removeAttribute('src');
	        if (slotState.placeholder) slotState.placeholder.hidden = false;
	        slotState.frame?.classList.remove('has-photo');
	        if (slotState.fileName) slotState.fileName.textContent = 'Seçilmedi';
	        if (slotState.adjust) slotState.adjust.hidden = true;
	        if (slotState.position) slotState.position.value = '';
	      }

      syncPreservedSlotUrl(slotState);
	      syncSlotTransform(slotState);
	    };

	    const setSlotFile = (slotState, file, shouldAssignInput = true) => {
	      if (!file) return;
	      if (shouldAssignInput) setInputFile(slotState.input, file);
	      if (slotState.objectUrl) URL.revokeObjectURL(slotState.objectUrl);
	      slotState.file = file;
	      slotState.objectUrl = URL.createObjectURL(file);
      slotState.existingUrl = '';
      slotState.upload = { file, promise: null, url: '', error: null };
	      slotState.scale = 1;
      slotState.x = 0;
      slotState.y = 0;
      slotState.referenceWidth = 0;
      slotState.referenceHeight = 0;

	      renderSlotState(slotState, false);
	      root.classList.remove('has-renao-collage-error');
	      updateProgress();
      uploadOriginalPhoto(slotState).catch((error) => {
        console.warn('Renao original collage photo upload will be retried at add to cart.', error);
      });
	    };

	    const swapSlotState = (slotState, targetSlotState) => {
	      if (!slotState || !targetSlotState) return;
	      if (slotState === targetSlotState) return;
	      const sourceName = slotState.file?.name || getFileNameFromUrl(slotState.existingUrl) || `Fotoğraf ${slotState.slot}`;
	      const targetName = targetSlotState.file?.name || getFileNameFromUrl(targetSlotState.existingUrl) || `Fotoğraf ${targetSlotState.slot}`;
	      const keys = ['file', 'objectUrl', 'existingUrl', 'upload', 'scale', 'x', 'y', 'referenceWidth', 'referenceHeight'];
	      const temp = {};
	      keys.forEach((key) => { temp[key] = slotState[key]; });
	      keys.forEach((key) => { slotState[key] = targetSlotState[key]; });
	      keys.forEach((key) => { targetSlotState[key] = temp[key]; });

	      renderSlotState(slotState, true);
	      renderSlotState(targetSlotState, true);
	      updateProgress();
	      updateError();
	      syncAllTransforms();
	      [slotState.slotElement, targetSlotState.slotElement].forEach((element) => {
	        if (!element) return;
	        element.classList.remove('is-renao-collage-swapping');
	        void element.offsetWidth;
	        element.classList.add('is-renao-collage-swapping');
	        window.setTimeout(() => element.classList.remove('is-renao-collage-swapping'), 520);
	      });
	      if (orderStatus) {
	        orderStatus.textContent = `${sourceName} ↔ ${targetName}`;
	        window.clearTimeout(orderStatus._renaoTimer);
	        orderStatus._renaoTimer = window.setTimeout(() => { orderStatus.textContent = defaultOrderHint; }, 1600);
	      }
	      prepareCropsInBackground();
	    };

    const openCrop = (slotState) => {
      const imageUrl = getSlotImageUrl(slotState);
      if (!imageUrl || !cropModal) return;
      showLivePreview();
      activeSlot = slotState;
      setSlotReferenceFromPreview(slotState);
      cropModal.hidden = false;
      document.documentElement.classList.add('renao-collage-crop-open');
      if (cropImage) cropImage.src = imageUrl;
      if (cropZoom) cropZoom.value = slotState.scale;
      window.requestAnimationFrame(() => {
        setSlotReferenceFromPreview(slotState);
        syncSlotTransform(slotState);
        window.requestAnimationFrame(() => {
          setSlotReferenceFromPreview(slotState);
          syncSlotTransform(slotState);
        });
      });
    };

    const closeCrop = () => {
      if (!cropModal) return;
      cropModal.hidden = true;
      document.documentElement.classList.remove('renao-collage-crop-open');
      dragState = null;
      activeSlot = null;
    };

    const setZoom = (nextZoom) => {
      if (!activeSlot) return;
      activeSlot.scale = clampZoom(nextZoom);
      if (cropZoom) cropZoom.value = activeSlot.scale;
      syncSlotTransform(activeSlot);
    };

    const moveCrop = (direction, amount = 14) => {
      if (!activeSlot) return;
      if (direction === 'up') activeSlot.y -= amount;
      if (direction === 'down') activeSlot.y += amount;
      if (direction === 'left') activeSlot.x -= amount;
      if (direction === 'right') activeSlot.x += amount;
      syncSlotTransform(activeSlot);
    };

	    const syncCaption = () => {
	      if (!captionInput || !captionPreview) return;
      if (isGarage) {
        captionInput.value = stripEmoji(captionInput.value).normalize('NFC').slice(0, captionMaxLength);
        captionPreview.textContent = captionInput.value.trim();
        if (captionCount) captionCount.textContent = `${captionInput.value.length}/${captionMaxLength}`;
        fitCaption();
        return;
      }
	      if (isWanted) {
        captionInput.value = stripEmoji(captionInput.value).normalize('NFC').slice(0, captionMaxLength);
        captionPreview.textContent = `Suçu : ${captionInput.value.trim() || defaultCaption}`;
        if (captionCount) captionCount.textContent = `${captionInput.value.length}/${captionMaxLength}`;
        fitCaption();
        return;
      }
      const normalizedCaption = normalizeCaptionCharacters(captionInput.value)
	        .toLocaleLowerCase('tr-TR')
	        .slice(0, captionMaxLength);
	      if (captionInput.value !== normalizedCaption) captionInput.value = normalizedCaption;
	      const renderedCaption = normalizedCaption.trim() || normalizeCaptionCharacters(defaultCaption).toLocaleLowerCase('tr-TR');
	      captionPreview.textContent = renderedCaption;
	      const captionLength = renderedCaption.length;
	      const captionLengthMode = captionLength <= 8 ? 'tiny' : captionLength > 23 ? 'long' : captionLength > 16 ? 'medium' : 'short';
	      const plaque = preview.querySelector('.renao-collage-plaque');
	      preview.dataset.renaoCaptionLength = captionLengthMode;
	      if (plaque) plaque.dataset.renaoCaptionLength = captionLengthMode;
	      if (captionCount) captionCount.textContent = `${normalizedCaption.length}/${captionMaxLength}`;
	      scheduleCaptionFit();
	    };

    const syncZrfkNote = () => {
      if (!zrfkNoteInput && !zrfkNotePreview) return;
      const maxLength = Number(zrfkNoteInput?.getAttribute('maxlength')) || 120;
      if (zrfkNoteInput) {
        const sanitizedNote = stripEmoji(zrfkNoteInput.value).slice(0, maxLength);
        if (zrfkNoteInput.value !== sanitizedNote) zrfkNoteInput.value = sanitizedNote;
      }

      const defaultNote = zrfkNoteInput?.placeholder || 'Hayatıma giren en güzel\nve en anlamlı hediyesin.\nSeni çok seviyorum sevgilim...';
      const note = zrfkNoteInput?.value.trim() || defaultNote;
      const lines = note
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);

      if (zrfkNoteCount && zrfkNoteInput) zrfkNoteCount.textContent = `${zrfkNoteInput.value.length}/${maxLength}`;
      if (zrfkNotePreview) zrfkNotePreview.innerHTML = lines.map((line) => `<span>${line.replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char])}</span>`).join('');
    };

    const formatBabyDate = (value) => {
      const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      return match ? `${match[3]} · ${match[2]} · ${match[1]}` : '18 · 08 · 2026';
    };

    const normalizeBabyDateInputValue = (value) => {
      const normalized = String(value || '').trim();
      const iso = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
      if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
      const displayed = normalized.match(/^(\d{2})[./-](\d{2})[./-](\d{4})$/);
      if (displayed) return `${displayed[3]}-${displayed[2]}-${displayed[1]}`;
      return '';
    };

    const uppercaseTurkish = (value) => String(value || '')
      .normalize('NFC')
      .replace(/i/g, 'İ')
      .replace(/ı/g, 'I')
      .toUpperCase();

    const fitBabyName = () => {
      if (!babyNamePreview) return;
      const isCompactBabyName = ['bebe3', 'bebe2', 'bebe'].includes(root.dataset.renaoSourceProductHandle);
      const isLandscapeBebe = root.dataset.renaoSourceProductHandle === 'bebe';
      const landscapeNameLength = Array.from(String(babyNamePreview.textContent || '').replace(/\s+/g, '')).length;
      const landscapeNameScale = landscapeNameLength > 7 ? 7 / landscapeNameLength : 1;
      const baseSize = isLandscapeBebe ? Math.max(3.25, 5.1 * landscapeNameScale) : isCompactBabyName ? 8.4 : 17.15;
      babyNamePreview.style.fontSize = `${baseSize}cqw`;
      const availableWidth = babyNamePreview.clientWidth;
      if (!availableWidth || !babyNamePreview.textContent?.trim()) return;
      const range = document.createRange();
      range.selectNodeContents(babyNamePreview);
      const measuredWidth = range.getBoundingClientRect().width;
      range.detach?.();
      if (!measuredWidth) return;
      const minimumSize = isLandscapeBebe ? 3.25 : isCompactBabyName ? 4.4 : 6.8;
      const fittedSize = Math.max(minimumSize, baseSize * Math.min(1, (availableWidth * 0.975) / measuredWidth));
      babyNamePreview.style.fontSize = `${fittedSize.toFixed(3)}cqw`;
    };

    const scheduleBabyNameFit = () => {
      window.cancelAnimationFrame(babyNameFitFrame);
      babyNameFitFrame = window.requestAnimationFrame(() => {
        fitBabyName();
        window.requestAnimationFrame(fitBabyName);
      });
    };

    const syncBabyFields = () => {
      if (!babyNameInput && !babyDateInput && !babyNoteInput) return;
      if (babyNameInput) {
        // Keep Turkish letters intact. NFC also keeps pasted decomposed forms
        // (for example S + combining cedilla) stable in the preview and PDF.
        const sanitizedName = stripEmoji(babyNameInput.value).normalize('NFC').replace(/\s+/g, ' ').slice(0, babyNameInput.maxLength || 20);
        if (babyNameInput.value !== sanitizedName) babyNameInput.value = sanitizedName;
        if (babyNamePreview) {
          const renderedName = uppercaseTurkish(sanitizedName.trim()) || (['bebe3', 'bebe2', 'bebe'].includes(root.dataset.renaoSourceProductHandle) ? 'LİNA' : 'MİRA');
          babyNamePreview.textContent = renderedName;
          scheduleBabyNameFit();
        }
      }
      if (babyDateInput?.value) {
        const normalizedDate = normalizeBabyDateInputValue(babyDateInput.value);
        if (normalizedDate && normalizedDate !== babyDateInput.value) babyDateInput.value = normalizedDate;
      }
      if (babyDatePreview) babyDatePreview.textContent = formatBabyDate(babyDateInput?.value);
      if (babyNoteInput) {
        const sanitizedNote = stripEmoji(babyNoteInput.value).replace(/\s+/g, ' ').slice(0, babyNoteInput.maxLength || 60);
        if (babyNoteInput.value !== sanitizedNote) babyNoteInput.value = sanitizedNote;
        if (babyNotePreview) {
          const renderedNote = sanitizedNote.trim() || 'Seni görmeden sevdik.';
          babyNotePreview.textContent = renderedNote;
          babyNotePreview.style.fontSize = renderedNote.length > 46 ? '2.25cqw' : renderedNote.length > 30 ? '2.55cqw' : '2.9cqw';
        }
      }
    };

    const ensureDefaultZrfkNoteValue = () => {
      if (!zrfkNoteInput || zrfkNoteInput.value.trim()) return;
      zrfkNoteInput.value = zrfkNoteInput.placeholder || '';
    };

    const setZrfkNoteStyle = (style) => {
      const normalizedStyle = style === 'classic' ? 'classic' : 'romantic';
      const label = normalizedStyle === 'classic' ? 'Zarif' : 'Romantik';
      const plaque = preview.querySelector('.renao-collage-plaque');

      root.dataset.renaoZrfkNoteStyle = normalizedStyle;
      preview.dataset.renaoZrfkNoteStyle = normalizedStyle;
      if (plaque) plaque.dataset.renaoZrfkNoteStyle = normalizedStyle;
      if (zrfkNoteStyleProperty) zrfkNoteStyleProperty.value = label;

      zrfkNoteStyleButtons.forEach((button) => {
        const isSelected = button.dataset.renaoZrfkNoteStyle === normalizedStyle;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });
    };

    const decodeHtmlEntities = (value) => {
      if (typeof value !== 'string') return value;
      const textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return textarea.value;
    };

    const normalizeCartEditProperties = (properties) => {
      if (!properties) return {};
      const normalizeEntry = (result, key, value) => {
        result[decodeHtmlEntities(key)] = decodeHtmlEntities(value);
        return result;
      };

      if (!Array.isArray(properties) && typeof properties === 'object') {
        return Object.entries(properties).reduce((result, [key, value]) => {
          if (Array.isArray(value) && value.length >= 2) return normalizeEntry(result, value[0], value[1]);
          if (value && typeof value === 'object' && value.first) return normalizeEntry(result, value.first, value.last);
          return normalizeEntry(result, key, value);
        }, {});
      }

      if (Array.isArray(properties)) {
        return properties.reduce((result, property) => {
          if (Array.isArray(property) && property.length >= 2) normalizeEntry(result, property[0], property[1]);
          if (property && typeof property === 'object' && property.first) normalizeEntry(result, property.first, property.last);
          return result;
        }, {});
      }

      return {};
    };

    const restoreRecipePhotoPositions = (properties) => {
      const normalized = normalizeCartEditProperties(properties);
      let recipeValue = String(normalized['_Renao Reçete'] || '');
      if (!recipeValue) {
        for (const propertyName of ['_Tasarım Dosyası', 'Tasarım Dosyası', '_Tasarım Önizleme', 'Tasarım Önizleme']) {
          try {
            const url = new URL(String(normalized[propertyName] || ''), window.location.origin);
            recipeValue = url.hash.match(/^#r=(v1\.[A-Za-z0-9_-]+)$/)?.[1]
              || url.searchParams.get('r')
              || '';
            if (recipeValue) break;
          } catch {
            // Empty or legacy design links may not contain a recipe.
          }
        }
      }
      if (!recipeValue.startsWith('v1.')) return normalized;

      try {
        const encoded = recipeValue.slice(3).replace(/-/g, '+').replace(/_/g, '/');
        const binary = atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '='));
        const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
        const recipe = JSON.parse(new TextDecoder().decode(bytes));
        Object.entries(recipe.p || {}).forEach(([shortName, value]) => {
          if (/^f\d+$/.test(shortName)) normalized[`_Fotoğraf ${shortName.slice(1)} Konumu`] = String(value);
        });
      } catch (error) {
        console.warn('Renao collage crop recipe could not be restored.', error);
      }
      return normalized;
    };

    const getCartEditKeyFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get('renao_edit');
    };

    const getCartEditState = () => {
      const editKey = getCartEditKeyFromUrl();
      if (!editKey) return null;

      try {
        const savedState = JSON.parse(window.sessionStorage.getItem(`renaoCartEdit:${editKey}`) || 'null');
        if (!savedState) return null;
        savedState.key = savedState.key || editKey;
        savedState.properties = restoreRecipePhotoPositions(savedState.properties);
        return savedState;
      } catch (error) {
        console.warn('Renao collage cart edit state could not be restored.', error);
        return null;
      }
    };

    const fetchCartEditState = (editKey) => {
      if (!editKey) return Promise.resolve(null);

      return fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      })
        .then((response) => response.ok ? response.json() : null)
        .then((cartState) => {
          const item = cartState?.items?.find((cartItem) => cartItem.key === editKey);
          if (!item) return null;

          return {
            key: item.key,
            quantity: item.quantity,
            variantId: item.variant_id,
            properties: restoreRecipePhotoPositions(item.properties),
          };
        })
        .catch((error) => {
          console.warn('Renao collage cart edit state could not be fetched.', error);
          return null;
        });
    };

    const setEditSubmitText = (productForm, attempt = 0) => {
      if (!productForm) return;
      const submitButtonText = productForm.querySelector('[type="submit"] span');
      if (submitButtonText) {
        submitButtonText.textContent = 'Düzenlemeyi Bitir';
        return;
      }
      if (attempt < 12) window.setTimeout(() => setEditSubmitText(productForm, attempt + 1), 80);
    };

    const applyGiftWrapEditValue = (productForm, value) => {
      if (!productForm || value === undefined) return;
      const giftWrapSelect = productForm.querySelector('[data-renao-gift-wrap-select]');
      if (!giftWrapSelect) return;
      const option = Array.from(giftWrapSelect.options).find((item) => item.value === value);
      if (option) giftWrapSelect.value = option.value;
    };

    const applyPhotoPositionValue = (slotState, value) => {
      const text = String(value || '');
      if (slotState.position) slotState.position.value = text;
      const x = text.match(/x:([-.\d]+)/);
      const y = text.match(/y:([-.\d]+)/);
      const zoom = text.match(/zoom:([-.\d]+)/);
      const normalizedX = text.match(/(?:^|[,;]\s*)nx:([-.\d]+)/);
      const normalizedY = text.match(/(?:^|[,;]\s*)ny:([-.\d]+)/);

      slotState.x = x ? Number.parseFloat(x[1]) || 0 : slotState.x;
      slotState.y = y ? Number.parseFloat(y[1]) || 0 : slotState.y;
      slotState.scale = zoom ? clampZoom(Number.parseFloat(zoom[1]) || 1) : slotState.scale;
      slotState.normalizedX = normalizedX ? Number.parseFloat(normalizedX[1]) : Number.NaN;
      slotState.normalizedY = normalizedY ? Number.parseFloat(normalizedY[1]) : Number.NaN;
      slotState.normalizedPositionApplied = false;
    };

    const setExistingSlotUrl = (slotState, url) => {
      const normalizedUrl = String(url || '').trim();
      if (!normalizedUrl) return;
      if (slotState.objectUrl) URL.revokeObjectURL(slotState.objectUrl);
      slotState.file = null;
      slotState.objectUrl = '';
      slotState.existingUrl = normalizedUrl;
      slotState.upload = null;
      renderSlotState(slotState, true);
    };

    const syncArk2Fields = () => {
      ark2Fields.forEach((field) => {
        const target = preview.querySelector(`[data-ark2-preview="${field.dataset.ark2Field}"]`);
        if (!target) return;
        field.setCustomValidity('');
        target.textContent = field.value.trim().normalize('NFC') || target.dataset.default;
        target.style.fontSize = '15px';
        const available = field.dataset.ark2Field === 'Tanışma Yılı' ? 43 : field.dataset.ark2Field === 'Bağlılık Süresi' ? 60 : 77;
        const width = target.getComputedTextLength();
        if (width > available) target.style.fontSize = `${15 * available / width}px`;
      });
    };
    const validateArk2Fields = () => {
      for (const field of ark2Fields) {
        const value = field.value.trim();
        const valid = value.length > 0 && value.length <= field.maxLength && (field.dataset.ark2Field !== 'Tanışma Yılı' || /^[0-9]{4}$/.test(value) && Number(value) > 0);
        field.setCustomValidity(valid ? '' : (field.dataset.ark2Field === 'Tanışma Yılı' ? 'Lütfen dört haneli bir yıl yazın.' : 'Lütfen bu alanı kısa bir cevapla doldurun.'));
        if (!valid) { field.reportValidity(); field.focus(); return false; }
      }
      return true;
    };
    const wrapArkadas3Note = (value) => {
      const context = document.createElement('canvas').getContext('2d');
      context.font = '400 14.65px "Renao Dancing Script"';
      const fits = (text) => Array.from(text).length <= 28 && context.measureText(text).width <= 178;
      const lines = [];
      String(value).normalize('NFC').replace(/\r/g, '').split('\n').forEach((paragraph) => {
        let line = '';
        for (const word of paragraph.trim().split(/\s+/).filter(Boolean)) {
          if (fits(line ? `${line} ${word}` : word)) { line = line ? `${line} ${word}` : word; continue; }
          if (line) { lines.push(line); line = ''; }
          for (const character of Array.from(word)) {
            if (!fits(line + character)) { lines.push(line); line = ''; }
            line += character;
          }
        }
        if (line) lines.push(line);
      });
      return lines;
    };
    const syncArkadas3Fields = () => {
      arkadas3Fields.forEach((field) => {
        const key = field.dataset.arkadas3Field;
        field.setCustomValidity('');
        const target = preview.querySelector(`[data-arkadas3-preview="${key}"]`);
        if (!target) return;
        const value = field.value.trim();
        if (key === 'Tasarım Notu') {
          const lines = wrapArkadas3Note(value || 'Yıllar değişti,\nYanımdaki yerin değişmedi');
          target.textContent = lines.slice(0, 2).join('\n');
          const status = root.querySelector('[data-arkadas3-note-status]');
          if (lines.length > 2) {
            field.setCustomValidity('Notunuz iki satıra sığmıyor. Yazı boyutu korunur; lütfen notunuzu kısaltın.');
            if (status) status.textContent = field.validationMessage;
          } else if (status) status.textContent = `${Array.from(value).length}/56 karakter · En fazla iki satır, satır başına 28 karakter. Yazı boyutu sabittir.`;
        } else target.textContent = value || (key === 'Üst Yıl' ? '2010' : '2026');
      });
    };
    const validateArkadas3Fields = () => {
      for (const field of arkadas3Fields) {
        const value = field.value.trim();
        const key = field.dataset.arkadas3Field;
        const valid = key === 'Tasarım Notu' ? Boolean(value) && value.length <= 56 && wrapArkadas3Note(value).length <= 2 : /^[0-9]{4}$/.test(value) && Number(value) > 0;
        field.setCustomValidity(valid ? '' : (key === 'Tasarım Notu' ? 'Lütfen en fazla iki satıra sığan bir not yazın. Yazı boyutu korunur; uzun notları kısaltın.' : 'Lütfen dört haneli bir yıl yazın.'));
        if (!valid) { field.reportValidity(); field.focus(); return false; }
      }
      return true;
    };

    const applyCartEditState = (editState) => {
      if (!editState || !editState.properties) return;
      const props = editState.properties;
      ark2Fields.forEach((field) => { if (props[field.dataset.ark2Field] !== undefined) field.value = String(props[field.dataset.ark2Field]); });
      syncArk2Fields();
      arkadas3Fields.forEach((field) => { if (props[field.dataset.arkadas3Field] !== undefined) field.value = String(props[field.dataset.arkadas3Field]); });
      syncArkadas3Fields();
      root.dispatchEvent(new CustomEvent('renao:arkadas:restore', { detail: props }));
      const productForm = getProductForm();

      if (productForm) {
        productForm.dataset.renaoEditKey = editState.key || '';
        productForm.dataset.renaoEditStorageKey = editState.key ? `renaoCartEdit:${editState.key}` : '';
        setEditSubmitText(productForm);
      }

      if (props['Fotoğraf Rengi']) setTone(String(props['Fotoğraf Rengi']).toLocaleLowerCase('tr-TR').includes('siyah') ? 'bw' : 'color');
      if (props['Görsel Tercihi']) setVisualStyle(props['Görsel Tercihi']);
      if (isWanted && captionInput && props['Suçu'] !== undefined) captionInput.value = String(props['Suçu']).slice(0, captionMaxLength);
      if (!isWanted && captionInput && props['Alt Yazı']) captionInput.value = String(props['Alt Yazı']).slice(0, captionMaxLength);
      if (zrfkNoteInput && props.Not !== undefined) zrfkNoteInput.value = stripEmoji(props.Not).slice(0, Number(zrfkNoteInput.getAttribute('maxlength')) || 120);
      if (zrfkNoteStyleProperty && props['Yazı Stili']) setZrfkNoteStyle(String(props['Yazı Stili']).toLocaleLowerCase('tr-TR').includes('zarif') ? 'classic' : 'romantic');
      if (babyNameInput && props['İsim'] !== undefined) babyNameInput.value = String(props['İsim']).slice(0, babyNameInput.maxLength || 20);
      if (babyDateInput && (props['Tarih'] !== undefined || props['_Tarih'] !== undefined)) {
        babyDateInput.value = normalizeBabyDateInputValue(props['Tarih'] ?? props['_Tarih']);
      }
      if (babyNoteInput && props['Bebek Notu'] !== undefined) babyNoteInput.value = String(props['Bebek Notu']).slice(0, babyNoteInput.maxLength || 60);

      slots.forEach((slotState) => {
        const photoUrl = props[`_Fotoğraf ${slotState.slot}`] || props[`Fotoğraf ${slotState.slot}`] || (slots.length === 1 ? (props._Fotoğraf || props.Fotoğraf) : '');
        if (photoUrl) setExistingSlotUrl(slotState, photoUrl);
        const positionValue = props[`_Fotoğraf ${slotState.slot} Konumu`] || props['_Fotoğraf Konumu'];
        if (positionValue) applyPhotoPositionValue(slotState, positionValue);
        renderSlotState(slotState, true);
      });

      const orderNote = productForm?.querySelector('[data-renao-order-note]');
      if (orderNote) {
        const orderNoteValue = zrfkNoteInput ? props['Sipariş Notu'] : props.Not;
        if (orderNoteValue !== undefined) orderNote.value = orderNoteValue;
      }
      applyGiftWrapEditValue(productForm, props['Hediye Paketi']);

      syncCaption();
      syncZrfkNote();
      syncBabyFields();
      syncAllTransforms();
      updateProgress();
      root.classList.toggle('has-renao-collage-error', !hasAllPhotos());
      showLivePreview();
    };

    const openProofModal = async () => {
      if (isGarage) { await document.fonts.load('25px "Renao Acardia"'); syncCaption(); }
      if (ark2Fields.length) { await document.fonts.load('15px \"Renao Ark2 Script\"'); syncArk2Fields(); }
      if (isWanted) {
        await document.fonts.load('14px "Renao Wanted"');
        fitCaption();
      }
      if (!proofModal || !proofStage) return;
      const plaque = preview.querySelector('.renao-collage-plaque');
      if (!plaque) return;
      proofStage.innerHTML = '';
      const proofPlaque = plaque.cloneNode(true);
      proofPlaque.style.maxWidth = '100%';
      proofStage.appendChild(proofPlaque);
      const proofPanel = proofModal.querySelector('.renao-proof-modal__panel');
      if (proofPanel) proofPanel.scrollTop = 0;
      proofModal.hidden = false;
      document.documentElement.classList.add('renao-proof-modal-open');
    };

    const closeProofModal = () => {
      if (!proofModal) return;
      proofModal.hidden = true;
      document.documentElement.classList.remove('renao-proof-modal-open');
    };

    const validateBeforeSubmit = (event) => {
      syncArk2Fields();
      if (!validateArk2Fields()) { event.preventDefault(); event.stopImmediatePropagation(); activateLivePreview(); return false; }
      if (isWanted) {
        syncCaption();
        if (!captionInput.value.trim()) {
          event.preventDefault(); event.stopImmediatePropagation();
          captionInput.focus(); captionInput.reportValidity(); return false;
        }
      }
      syncArkadas3Fields();
      if (!validateArkadas3Fields()) {
        event.preventDefault(); event.stopImmediatePropagation(); activateLivePreview(); return false;
      }
      if (zrfkNoteInput) {
        ensureDefaultZrfkNoteValue();
        const maxLength = Number(zrfkNoteInput.getAttribute('maxlength')) || 120;
        zrfkNoteInput.value = stripEmoji(zrfkNoteInput.value)
          .split(/\r?\n/)
          .map((line) => line.trim())
          .filter(Boolean)
          .join('\n')
          .slice(0, maxLength);
        syncZrfkNote();
      }
      syncBabyFields();
      const firstMissingBabyField = [babyNameInput, babyDateInput, babyNoteInput]
        .filter(Boolean)
        .find((field) => !String(field.value || '').trim());
      if (firstMissingBabyField) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
        activateLivePreview();
        firstMissingBabyField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => firstMissingBabyField.focus({ preventScroll: true }), 280);
        return false;
      }
      if (hasAllPhotos()) return true;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      updateError();
      activateLivePreview();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => bulkButton?.focus?.({ preventScroll: true }), 280);
      return false;
    };

    ark2Fields.forEach((field) => field.addEventListener('input', () => { activateLivePreview(); syncArk2Fields(); }));
    if (isGarage) document.fonts.load('25px "Renao Acardia"').then(syncCaption);
    if (ark2Fields.length) document.fonts.load('15px \"Renao Ark2 Script\"').then(syncArk2Fields);
    arkadas3Fields.forEach((field) => field.addEventListener('input', () => { activateLivePreview(); syncArkadas3Fields(); }));
    root.querySelector('[data-arkadas3-swap]')?.addEventListener('click', () => {
      if (!hasAllPhotos()) { updateError(); bulkButton?.focus(); return; }
      activateLivePreview(); swapSlotState(slots[0], slots[1]);
    });
    if ((arkadas3Fields.length || ark2Fields.length || isWanted || isGarage) && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!root.isConnected || String(root.closest('product-info')?.dataset.section) !== String(data?.sectionId)) return;
        const form = getProductForm();
        const editKey = form?.dataset.renaoEditKey;
        if (!editKey) return;
        if (data.variant?.available) setEditSubmitText(form);
        const url = new URL(window.location.href);
        url.searchParams.set('renao_edit', editKey);
        window.history.replaceState({}, '', url);
      });
    }
    syncArkadas3Fields();
    bulkButton?.addEventListener('click' , () => bulkInput?.click());
	    bulkInput?.addEventListener('change', async () => {
      const selectedFiles = Array.from(bulkInput.files || []);
      if (selectedFiles.length > slots.length) {
        bulkInput.value = '';
        if (orderStatus) orderStatus.textContent = `En fazla ${slots.length} fotoğraf seçebilirsiniz.`;
        if (bulkButton) bulkButton.setAttribute('aria-invalid', 'true');
        window.alert(`Bu tasarım için tam ${slots.length} fotoğraf seçin. ${slots.length} adetten fazlası kabul edilmez.`);
        return;
      }
      if (bulkButton) bulkButton.removeAttribute('aria-invalid');
      const qualityResults = await Promise.all(selectedFiles.map(checkPhotoQuality));
      const rejectedItems = qualityResults
        .map((result, index) => ({ result, index }))
        .filter(({ result }) => !result.accepted);
      const message = qualityMessage(rejectedItems);
      showQualityMessage(message);
      if (!rejectedItems.length && orderStatus) orderStatus.textContent = 'Fotoğraflar sipariş için hazırlanıyor…';
      const preparedFiles = await Promise.all(selectedFiles.map((file, index) => (
        qualityResults[index].accepted ? preparePhotoForShopify(file, index + 1) : Promise.resolve(file)
      )));
      preparedFiles.forEach((file, index) => {
        if (qualityResults[index].accepted) setSlotFile(slots[index], file, true);
      });
      if (!rejectedItems.length && orderStatus) orderStatus.textContent = defaultOrderHint;
      if (rejectedItems.length) {
        bulkInput.value = '';
        if (bulkButton) bulkButton.setAttribute('aria-invalid', 'true');
      }
      syncAllTransforms();
      updateError();
      prepareCropsInBackground();
      const firstAcceptedIndex = qualityResults.findIndex((result) => result.accepted);
      if (firstAcceptedIndex >= 0) openCrop(slots[firstAcceptedIndex]);
    });

	    slots.forEach((slotState) => {
      slotState.pick?.addEventListener('click', () => slotState.input?.click());
      slotState.frame?.addEventListener('click', () => {
        if (slotState.objectUrl) {
          openCrop(slotState);
        } else {
          slotState.input?.click();
        }
      });
      slotState.adjust?.addEventListener('click', () => openCrop(slotState));
	      slotState.input?.addEventListener('change', async () => {
        const file = slotState.input.files && slotState.input.files[0];
        if (!file) return;
        const qualityResult = await checkPhotoQuality(file);
        if (!qualityResult.accepted) {
          showQualityMessage(qualityMessage([{ index: slotState.slot - 1, result: qualityResult }]));
          clearInputFile(slotState.input);
          return;
        }
        showQualityMessage('');
        const preparedFile = await preparePhotoForShopify(file, slotState.slot);
        setSlotFile(slotState, preparedFile, true);
        updateError();
        prepareCropsInBackground();
        openCrop(slotState);
      });
    });

    cropStage?.addEventListener('pointerdown', (event) => {
      if (!activeSlot) return;
      event.preventDefault();
      event.stopPropagation();
      cropStage.setPointerCapture(event.pointerId);
      dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        originX: activeSlot.x,
        originY: activeSlot.y,
      };
    });

    cropStage?.addEventListener('pointermove', (event) => {
      if (!activeSlot || !dragState || dragState.pointerId !== event.pointerId) return;
      event.preventDefault();
      event.stopPropagation();
      activeSlot.x = dragState.originX + event.clientX - dragState.startX;
      activeSlot.y = dragState.originY + event.clientY - dragState.startY;
      syncSlotTransform(activeSlot);
    });

    cropStage?.addEventListener('pointerup', (event) => {
      event.preventDefault();
      if (dragState?.pointerId === event.pointerId) dragState = null;
    });

    cropStage?.addEventListener('dragstart', (event) => event.preventDefault());
    cropStage?.addEventListener('pointercancel', () => { dragState = null; });
    cropStage?.addEventListener('lostpointercapture', () => { dragState = null; });
    cropStage?.addEventListener('wheel', (event) => {
      if (!activeSlot) return;
      event.preventDefault();
      setZoom(activeSlot.scale + (event.deltaY > 0 ? -0.08 : 0.08));
    }, { passive: false });

    cropZoom?.addEventListener('input', () => setZoom(cropZoom.value));
    cropMoveButtons.forEach((button) => {
      button.addEventListener('click', () => moveCrop(button.dataset.renaoCollageCropMove));
    });
    cropZoomStepButtons.forEach((button) => {
      button.addEventListener('click', () => setZoom((activeSlot?.scale || 1) + Number(button.dataset.renaoCollageCropZoomStep || 0)));
    });
    cropReset?.addEventListener('click', () => {
      if (!activeSlot) return;
      activeSlot.scale = 1;
      activeSlot.x = 0;
      activeSlot.y = 0;
      setZoom(1);
    });
    cropApply?.addEventListener('click', () => {
      globalThis.RenaoCropRecipe?.syncForm?.(getProductForm());
      prepareCropsInBackground();
      closeCrop();
    });
    cropCancelButtons.forEach((button) => button.addEventListener('click', closeCrop));

    // The crop modal lives under <body>, while Shopify can refresh the product
    // form independently. Persist the live slot state into the currently
    // connected form after every crop interaction so cart editing always has
    // an authoritative x/y/zoom recipe.
    const persistConnectedCropState = () => {
      slots.forEach((slotState) => {
        const input = document.querySelector(`[data-renao-collage-position="${slotState.slot}"]`);
        if (!input) return;
        const width = slotState.referenceWidth || slotState.image?.parentElement?.clientWidth || 1;
        const height = slotState.referenceHeight || slotState.image?.parentElement?.clientHeight || 1;
        const normalizedX = slotState.x / width;
        const normalizedY = slotState.y / height;
        input.value = `x:${Math.round(slotState.x)}, y:${Math.round(slotState.y)}, zoom:${slotState.scale.toFixed(2)}, nx:${normalizedX.toFixed(6)}, ny:${normalizedY.toFixed(6)}`;
        input.setAttribute('value', input.value);
        slotState.position = input;
      });
      globalThis.RenaoCropRecipe?.syncForm?.(getProductForm());
    };
    const scheduleConnectedCropPersist = () => window.requestAnimationFrame(persistConnectedCropState);
    cropModal?.addEventListener('click', scheduleConnectedCropPersist);
    cropZoom?.addEventListener('input', scheduleConnectedCropPersist);

	    captionInput?.addEventListener('input', () => {
	      activateLivePreview();
	      syncCaption();
	    });

	    zrfkNoteInput?.addEventListener('input', () => {
	      activateLivePreview();
	      syncZrfkNote();
	    });

	    [babyNameInput, babyDateInput, babyNoteInput].filter(Boolean).forEach((field) => {
	      field.addEventListener('input', () => {
	        activateLivePreview();
	        syncBabyFields();
	      });
	      field.addEventListener('change', syncBabyFields);
	    });

	    zrfkNoteStyleButtons.forEach((button) => {
	      button.addEventListener('click', () => {
	        activateLivePreview();
	        setZrfkNoteStyle(button.dataset.renaoZrfkNoteStyle);
	      });
	    });

	    slots.forEach((slotState) => {
	      const element = slotState.slotElement;
	      if (!element) return;
	      element.addEventListener('dragstart', (event) => {
	        draggedSlot = slotState;
	        element.classList.add('is-renao-collage-dragging');
	        event.dataTransfer.effectAllowed = 'move';
	        event.dataTransfer.setData('text/plain', String(slotState.slot));
	      });
	      element.addEventListener('dragenter', (event) => {
	        event.preventDefault();
	        if (draggedSlot && draggedSlot !== slotState) element.classList.add('is-renao-collage-drop-target');
	      });
	      element.addEventListener('dragover', (event) => {
	        event.preventDefault();
	        event.dataTransfer.dropEffect = 'move';
	      });
	      element.addEventListener('dragleave', () => {
	        element.classList.remove('is-renao-collage-drop-target');
	      });
	      element.addEventListener('drop', (event) => {
	        event.preventDefault();
	        element.classList.remove('is-renao-collage-drop-target');
	        if (!draggedSlot || draggedSlot === slotState) return;
	        activateLivePreview();
	        swapSlotState(draggedSlot, slotState);
	      });
	      element.addEventListener('dragend', () => {
	        element.classList.remove('is-renao-collage-dragging');
	        root.querySelectorAll('.is-renao-collage-drop-target').forEach((target) => {
	          target.classList.remove('is-renao-collage-drop-target');
	        });
	        draggedSlot = null;
	      });
	    });

	    toneButtons.forEach((button) => {
	      button.addEventListener('click', () => {
	        activateLivePreview();
	        setTone(button.dataset.renaoCollageToneOption);
	      });
	    });

	    visualStyleOptions.forEach((button) => {
	      button.addEventListener('click', () => {
	        activateLivePreview();
	        setVisualStyle(button.dataset.renaoVisualStyleOption);
	      });
	    });

    proofOpen?.addEventListener('click', () => {
      showLivePreview();
      prepareCropsInBackground();
      openProofModal();
    });
    proofCloseButtons.forEach((button) => button.addEventListener('click', closeProofModal));

    root.addEventListener('pointerdown', activateLivePreview, { capture: true });
    root.addEventListener('focusin', activateLivePreview);
    root.addEventListener('input', activateLivePreview);
	    root.addEventListener('change', activateLivePreview);
	    window.addEventListener('resize', scheduleCaptionFit);
      window.addEventListener('resize', scheduleBabyNameFit);
	    getProductForm()?.addEventListener('submit', validateBeforeSubmit, true);

	    setTone(root.dataset.renaoCollageTone || 'color');
	    setVisualStyle(visualStyleInput?.value || 'Fotoğraf olarak kalsın');
	    setZrfkNoteStyle(root.dataset.renaoZrfkNoteStyle || 'romantic');
	    updateProgress();
	    syncCaption();
	    ensureDefaultZrfkNoteValue();
	    syncZrfkNote();
	    syncBabyFields();
	    syncAllTransforms();
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        syncArkadas3Fields();
        scheduleCaptionFit();
        scheduleBabyNameFit();
      }).catch(() => {});
    }
    document.fonts?.addEventListener?.('loadingdone', () => {
      scheduleCaptionFit();
      scheduleBabyNameFit();
    });
    const editState = getCartEditState();
    if (editState) {
      applyCartEditState(editState);
    } else {
      const editKey = getCartEditKeyFromUrl();
      if (editKey) fetchCartEditState(editKey).then(applyCartEditState);
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-renao-collage-personalizer]').forEach(initCollagePersonalizer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();

;(() => {
  const MARK = 'data-renao-live-stacked-frames';
  const CENTER_BANDS = 'M 160.265625 126.351562 C 160.269531 126.351562 160.269531 126.351562 160.273438 126.351562 C 165.328125 148.15625 170.378906 169.957031 175.4375 191.761719 C 175.929688 193.886719 175.953125 193.886719 178.164062 193.371094 C 211.675781 185.546875 245.1875 177.726562 278.699219 169.898438 C 281.398438 169.265625 281.300781 169.628906 280.679688 166.957031 C 270.605469 123.476562 260.527344 80 250.449219 36.519531 C 249.992188 34.554688 249.988281 34.546875 247.890625 35.035156 C 214.09375 42.863281 180.292969 50.691406 146.496094 58.523438 C 146.222656 58.585938 145.855469 58.574219 145.695312 58.738281 C 145.363281 59.074219 144.976562 59.488281 144.921875 59.898438 C 144.859375 60.402344 145.105469 60.941406 145.226562 61.460938 C 150.238281 83.089844 155.253906 104.722656 160.265625 126.351562 M 153.59375 137.261719 C 146.683594 107.441406 139.769531 77.621094 132.859375 47.796875 C 132.3125 45.441406 132.933594 44.515625 135.40625 43.949219 C 168.949219 36.296875 202.492188 28.664062 236.023438 20.957031 C 239.433594 20.175781 242.738281 18.929688 246.113281 17.976562 C 248.277344 17.371094 250.476562 16.878906 252.671875 16.398438 C 253.601562 16.195312 255.488281 17.425781 255.820312 18.386719 C 256.011719 18.929688 256.128906 19.5 256.257812 20.0625 C 269.929688 79.332031 283.597656 138.601562 297.261719 197.871094 C 297.378906 198.390625 297.527344 198.910156 297.574219 199.441406 C 297.707031 200.898438 296.738281 202.085938 295.332031 202.363281 C 288.34375 203.738281 281.3125 204.949219 274.375 206.546875 C 244.636719 213.402344 214.917969 220.363281 185.203125 227.324219 C 183.070312 227.824219 180.984375 228.582031 178.921875 229.339844 C 176.71875 230.148438 174.691406 229.222656 174.183594 227.035156 C 167.25 197.128906 160.316406 167.21875 153.386719 137.3125 C 153.457031 137.296875 153.527344 137.277344 153.59375 137.261719 ';
  let sourcePromise = null;

  const getSource = () => {
    if (sourcePromise) return sourcePromise;
    const scriptUrl = Array.from(document.scripts)
      .map((script) => script.src)
      .find((url) => url.includes('/renao-collage-personalizer.js')) || location.href;
    const frameUrl = new URL('renao-zarif-yatay-3-frame-vector.svg', scriptUrl).href;
    sourcePromise = fetch(frameUrl, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error('Zarif yatay vektor cerceve indirilemedi.');
        return response.text();
      })
      .then((text) => {
        const svg = new DOMParser().parseFromString(text, 'image/svg+xml').documentElement;
        const centerPath = svg.querySelector('path');
        if (centerPath) centerPath.setAttribute('d', CENTER_BANDS);
        return svg;
      });
    return sourcePromise;
  };

  const decorate = async () => {
    const plaques = document.querySelectorAll(
      '.renao-collage-plaque[data-renao-product-handle="zarif-yatay-3"][data-renao-source-product-handle="zarif-yatay-3"]'
    );
    for (const plaque of plaques) {
      const board = plaque.querySelector('.renao-collage-board');
      if (!board || board.getAttribute(MARK)) continue;
      board.setAttribute(MARK, 'pending');
      try {
        const source = await getSource();
        const paths = Array.from(source.querySelectorAll('path')).slice(0, 3);
        if (paths.length !== 3) throw new Error('Zarif yatay vektor yol sayisi gecersiz.');
        board.querySelectorAll('[data-renao-live-frame-vector]').forEach((item) => item.remove());
        paths.forEach((path, index) => {
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', source.getAttribute('viewBox') || '0 0 425.197 283.465');
          svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('data-renao-live-frame-vector', String(index + 1));
          const defs = source.querySelector('defs');
          if (defs) svg.appendChild(defs.cloneNode(true));
          svg.appendChild(path.cloneNode(true));
          Object.assign(svg.style, {
            position: 'absolute',
            inset: '0',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: String([2, 4, 6][index])
          });
          board.appendChild(svg);
        });
        board.classList.add('renao-live-stacked-frames');
        board.setAttribute(MARK, 'ready');
      } catch (error) {
        board.querySelectorAll('[data-renao-live-frame-vector]').forEach((item) => item.remove());
        board.removeAttribute(MARK);
        console.warn('Renao live frame stacking failed.', error);
      }
    }
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      decorate();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
